import { Page, PageTitleWithBack } from '../../../components';
import { BulkOptionInclusionsForm } from './bulk-option-inclusions-form';

export const BulkOptionInclusionsPage = () => {
  return (
    <>
      <Page title="Bulk Option Inclusions">
        <PageTitleWithBack backText="Back to Admin" backUrl={'/admin'} title="Bulk Option Inclusions" />
        <BulkOptionInclusionsForm />
      </Page>
    </>
  );
};
